import { Button, Flex, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import DownloadIcon from '@/assets/icons/ic-download-thin.svg';
import LinkOuterIcon from '@/assets/icons/ic-link-outer.svg';
import EmailIcon from '@/assets/icons/ic-share-email-40.svg';

import { CoreHeroBody, CoreHeroTitle, CoreHero } from '@/components/ui/shared/heroes/CoreHero/CoreHero';

interface ILibrariansHeaderProps {
  onOpen: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const LibrariansHeader: FC<ILibrariansHeaderProps> = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <CoreHero>
      <CoreHeroBody px={{ base: 5, md: 10, lg: 5 }}>
        <CoreHeroTitle
          lineHeight={{ base: '40px', md: '60px', lg: '80px' }}
          fontSize={{ base: '36px', md: '52px', lg: '72px' }}
          _after={{
            content: '""',
            display: 'block',
            width: { base: 5, md: 7, lg: 9 },
            height: 1,
            backgroundColor: 'currentColor',
            ml: '3px',
          }}
        >
          {t('librarians.header.title')}
        </CoreHeroTitle>
        <Text
          lineHeight={{ base: 5, md: '26px', lg: 10 }}
          fontSize={{ base: 'md', md: 'xl', lg: '28px' }}
          fontFamily="body"
          color="white"
          pb={{ base: 14, lg: 24 }}
          maxW="658px"
        >
          {t('librarians.header.description')}
        </Text>
        <Flex pb={14} flexWrap="wrap">
          <Button
            as="a"
            target="_blank"
            download
            href="https://drive.google.com/file/d/1KtRA7YCWgl5RBO-YD31wDuq7TGqpeJIb/view?usp=sharing"
            rightIcon={<DownloadIcon />}
            colorScheme="black"
            order={{ base: 2, lg: 1 }}
            mr={{ base: 5, md: 8 }}
            mb={{ base: 5, md: 0 }}
          >
            {t('librarians.header.downloadBrochure')}
          </Button>

          <Button
            onClick={onOpen}
            rightIcon={<EmailIcon width={25} />}
            colorScheme="black"
            textTransform="capitalize"
            order={{ base: 3, lg: 2 }}
            mr={{ base: 5, md: 8 }}
          >
            {t('librarians.header.contactUs')}
          </Button>

          <Button
            as={NextLink}
            href="/librarians-resource"
            rightIcon={<LinkOuterIcon />}
            colorScheme="black"
            textTransform="capitalize"
            order={{ base: 1, md: 1, lg: 3 }}
            mr={{ base: 5, md: 8 }}
            mb={{ base: 5, lg: 0 }}
          >
            {t('librarians.header.resourceCenter')}
          </Button>
        </Flex>
      </CoreHeroBody>
    </CoreHero>
  );
};
